module.exports = __webpack_public_path__ + "img/ctrl-cross-resonance-dagger-stub-+i.f14470df.svg";